import { INTERVIEW_STATUS_DECLINE, INTERVIEW_STATUS_DEFINITION, } from '@/define/consts/rfp/rfp_interview_define';
import { VIEW_REQUEST_PROPOSAL_REFUSE, VIEW_REQUEST_PROPOSAL_TODO, VIEW_REQUEST_PROPOSAL_UNREGISTERED, } from '@/utils/constants/viewRequest/proposal';
import { VIEW_REQUEST_STATUS_DISAPPROVED } from '@/utils/constants/viewRequest/status';
// ステータス取得
export const getStatus = (args) => {
    const { hasOffer, interviewStatus, viewRequestProposal, viewRequestStatus } = args;
    // 発注
    if (interviewStatus === INTERVIEW_STATUS_DEFINITION.value) {
        return 'interviewOrder';
    }
    // 閲覧拒否
    if (viewRequestStatus === VIEW_REQUEST_STATUS_DISAPPROVED.value) {
        return 'statusDisapproved';
    }
    // 見送り
    if (interviewStatus === INTERVIEW_STATUS_DECLINE.value) {
        return 'interviewDecline';
    }
    // 提案
    if (hasOffer) {
        return 'offered';
    }
    // 提案辞退
    if (viewRequestProposal === VIEW_REQUEST_PROPOSAL_REFUSE.value) {
        return 'proposalRefuse';
    }
    // 提案予定
    if (viewRequestProposal === VIEW_REQUEST_PROPOSAL_TODO.value) {
        return 'proposalToDo';
    }
    // 詳細確認中
    if (viewRequestProposal === VIEW_REQUEST_PROPOSAL_UNREGISTERED.value) {
        return 'confirmDetail';
    }
    // 提案検討中
    return 'proposalDoing';
};
